export namespace MoyenPaiementForm {
  export type FormEnum =
    'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementPrelevementType' |
    'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementVirementType' |
    'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementStandardType' |
    'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementChequeType' |
    'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementChequeRemboursementType';

  export const FormEnum = {
    Prelevement: 'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementPrelevementType' as FormEnum,
    Virement: 'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementVirementType' as FormEnum,
    Standard: 'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementStandardType' as FormEnum,
    Cheque: 'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementChequeType' as FormEnum,
    ChequeRemboursement: 'App\\Ekipea\\Bundle\\CoreBundle\\Form\\Type\\Paiement\\PaiementChequeRemboursementType' as FormEnum
  };
}



// WEBPACK FOOTER //
// ./src/shared/models/moyenPaiement/moyen-paiement-form.ts